/**
 * Utility functions for landing page URL generation and validation
 */

/**
 * Generate landing page URL from slug
 */
export const landingPageUrl = (slug: string): string => {
  return `/alleen-naar-${slug}`;
};

/**
 * Extract slug from landing page URL
 */
export const extractLandingPageSlug = (pathname: string): string | null => {
  const prefix = '/alleen-naar-';
  if (!pathname.startsWith(prefix)) {
    return null;
  }
  return pathname.slice(prefix.length);
};

/**
 * Validate if a pathname is a landing page URL
 */
export const isLandingPageUrl = (pathname: string): boolean => {
  return pathname.startsWith('/alleen-naar-');
};

/**
 * Generate full URL for social sharing
 */
export const getFullLandingPageUrl = (slug: string): string => {
  const baseUrl = process.env.REACT_APP_BASE_URL || 'https://solofix.nl';
  return `${baseUrl}/alleen-naar-${slug}`;
};

/**
 * Generate preview URL for admin interface
 */
export const getPreviewLandingPageUrl = (slug: string): string => {
  if (!slug) return '#';
  return landingPageUrl(slug);
};